/** UI timing shared by the lesson player and celebrations (kept apart so the start screen does not load the player). */
// `?fast=1` (tests) is remembered per tab; read it here, where FAST is computed (this module loads first).
try {
  const qs = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
  if (typeof sessionStorage !== 'undefined' && qs.has('fast')) sessionStorage.setItem('sk-fast', qs.get('fast') || '1');
} catch {
  /* storage blocked */
}
export const FAST = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('sk-fast') === '1' ? 8 : 1;
/** Scale a UI wait (ms) for fast mode. */
export const wait = (ms: number) => Math.round(ms / FAST);
